import { cn } from '@shared/lib/utils';

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
}

export function PageContainer({ children, className }: PageContainerProps) {
  return (
    <div
      className={cn(
        'mx-auto w-full min-w-0 max-w-[1280px]',
        'px-[var(--layout-page-padding-x-mobile)] sm:px-[var(--layout-page-padding-x-tablet)] lg:px-[var(--layout-page-padding-x)]',
        className
      )}
    >
      {children}
    </div>
  );
}
